import type { ReactNode } from 'react';

export const symbol_orders: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M164-220v-457L95-826q-5-11-1-23t15-17q12-6 24.5-1.5T151-851l77 174h505l77-174q5.34-11.67 17.17-16.33Q839-872 851-866q11 5 15.5 17.5T866-825l-69 148v457q0 24.75-17.62 42.37Q761.75-160 737-160H224q-24.75 0-42.37-17.63Q164-195.25 164-220Zm232-237h170q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5H396q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.37 8.5ZM224-220h513v-397H224v397Zm0 0v-397 397Z"
		/>
	</svg>
);
